// Mock data for Infinity Capital Inc website

export const testimonials = [
  {
    id: 1,
    name: "Michael Richardson",
    company: "Richardson Ventures",
    role: "CEO",
    content: "Infinity Capital's strategic approach to stock market investments has consistently delivered exceptional returns. Their team's expertise and market insights are unparalleled.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Chen",
    company: "Global Properties LLC",
    role: "Investment Director",
    content: "Working with Infinity Capital on our real estate portfolio has been transformative. They identified prime opportunities that exceeded our expectations significantly.",
    rating: 5
  },
  {
    id: 3,
    name: "David Armstrong",
    company: "Armstrong Industries",
    role: "CFO",
    content: "The heavy equipment leasing program provided by Infinity Capital enabled us to scale operations without massive capital outlay. Truly a game-changer for our business.",
    rating: 5
  },
  {
    id: 4,
    name: "Jennifer Martinez",
    company: "Energy Horizon Partners",
    role: "Managing Partner",
    content: "Their oil and gas exploration investments have consistently outperformed market benchmarks. Infinity Capital's due diligence and risk management are exceptional.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is the minimum investment amount?",
    answer: "Our minimum investment varies by sector. For stock market investments, we start at $250,000. Real estate opportunities begin at $100,000, while technology startups typically require $100,000 minimum. Heavy equipment leasing and oil & gas exploration require $250,000 minimum. We customize solutions based on your investment goals."
  },
  {
    id: 2,
    question: "What types of returns can I expect?",
    answer: "Returns vary by investment type and market conditions. Historically, our stock market portfolios have delivered 12-18% annually, real estate investments 10-15%, equipment leasing 8-12%, and oil & gas ventures 15-25%. Past performance doesn't guarantee future results, but we maintain rigorous standards."
  },
  {
    id: 3,
    question: "How does Infinity Capital manage risk?",
    answer: "We employ a multi-layered risk management approach including thorough due diligence, portfolio diversification, regular market analysis, and strategic hedging. Our experienced team continuously monitors all investments and adjusts strategies to protect and grow your capital."
  },
  {
    id: 4,
    question: "What is the investment timeline?",
    answer: "Investment timelines depend on the asset class. Stock market investments offer liquidity with quarterly withdrawal options. Real estate typically requires 3-7 year commitments. Equipment leasing contracts run 2-5 years, while oil & gas projects generally span 5-10 years with phased returns."
  },
  {
    id: 5,
    question: "How do I get started with Infinity Capital?",
    answer: "Getting started is simple: Schedule a consultation through our website, meet with our investment advisors to discuss your goals and risk tolerance, review our customized investment proposal, and complete the onboarding process. We guide you through every step."
  },
  {
    id: 6,
    question: "Are investments insured or guaranteed?",
    answer: "While we cannot guarantee returns due to market nature, we implement comprehensive risk mitigation strategies. Some investments carry insurance coverage, and we maintain reserve funds. We're transparent about risks and work diligently to protect your investments."
  }
];

export const services = [
  {
    id: 1,
    title: "Stock Market Investment",
    description: "Strategic portfolio management with data-driven insights and active trading strategies designed to maximize returns while managing risk across diverse market sectors.",
    features: [
      "Diversified portfolio strategies",
      "Real-time market analysis",
      "Professional fund management",
      "Quarterly performance reviews"
    ]
  },
  {
    id: 2,
    title: "Real Estate Investment",
    description: "Premium commercial and residential property investments in high-growth markets, offering stable income streams and long-term capital appreciation potential.",
    features: [
      "Prime location properties",
      "Commercial & residential options",
      "Passive income generation",
      "Property management included"
    ]
  },
  {
    id: 3,
    title: "Technology Startups",
    description: "Strategic investments in high-potential technology startups and innovative ventures, providing early-stage capital to disruptive companies with exceptional growth prospects.",
    features: [
      "Early-stage venture capital",
      "Tech sector specialization",
      "Portfolio diversification",
      "High growth potential"
    ]
  },
  {
    id: 4,
    title: "Tax Strategy Planning",
    description: "Expert tax optimization strategies to minimize capital gains taxes and maximize after-tax returns through sophisticated planning, timing, and legal structures.",
    features: [
      "Capital gains tax reduction",
      "Tax-loss harvesting strategies",
      "Qualified opportunity zones",
      "Legal structure optimization"
    ]
  },
  {
    id: 5,
    title: "Heavy Equipment Lease",
    description: "Strategic equipment leasing programs providing steady returns through industrial machinery, construction equipment, and specialized tools leased to established businesses.",
    features: [
      "Industrial machinery portfolio",
      "Maintenance-free investments",
      "Long-term lease contracts",
      "Stable monthly returns"
    ]
  },
  {
    id: 6,
    title: "Oil & Gas Exploration",
    description: "High-yield opportunities in proven oil and gas reserves, combining cutting-edge exploration technology with experienced operators to maximize extraction efficiency.",
    features: [
      "Proven reserve investments",
      "Expert geological analysis",
      "Advanced drilling technology",
      "Strong ROI potential"
    ]
  }
];

export const contactFormSubmit = (formData) => {
  // Mock form submission
  console.log('Form submitted:', formData);
  // Store in browser's session storage for demo
  const submissions = JSON.parse(sessionStorage.getItem('contactSubmissions') || '[]');
  submissions.push({ ...formData, timestamp: new Date().toISOString() });
  sessionStorage.setItem('contactSubmissions', JSON.stringify(submissions));
  return Promise.resolve({ success: true, message: 'Thank you for your interest! We will contact you within 24 hours.' });
};
